import React from 'react';
import Chart from "react-apexcharts";
import global from '../../../common/utility/global';

export default function GraficoRankingTotalVentas(props) {
    
  const options = {
    series: props.series,
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false
      },
    },
    stroke: {
      width: [0, 4]
    },
    title: {
      text: 'Cliente Ranking - Total Ventas (S/)',
      align: 'center',
      style: {
        fontSize: "18px",
        fontWeight: "bold",
        fontFamily: undefined,
        color: "#263238",
      },
    },
    dataLabels: {
      enabled: true,
      formatter : function (val) {
        return global.decimalFormat(val.toFixed(2))
      }
    },
    labels: props.clientes,
    xaxis: {
      type: 'text'
    },
    yaxis: [{
      title: {
        text: 'Total Venta (S/)',
      },
      labels: {
        formatter : function (val) {
          return global.decimalFormat(val.toFixed(2))
        }
      }
    }, {
      opposite: true,
      title: {
        text: 'Cantidad Comprobantes'
      },
      labels: {
        formatter : function (val) {
          return global.decimalFormat(parseInt(val))
        }
      }
    }]
  };


    return (
      <div id="chart">
        <Chart options={options} series={options.series} type="line" height={350} />
      </div>
    );
}